import React, { Component } from 'react';

import Header from './../Header';
import ErrorBoundary from './ErrorBoundary';

class Login extends Component
{

    componentDidMount()
    {
        document.title = "W-F: Connexion";
    }

    render()
    {
        return (
            <ErrorBoundary>
                <Header />
                <div className="container-fluid">

                </div>
            </ErrorBoundary>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/Components/Views/Login.js